import {
  dateFormats
} from 'application/src/js/globals.js';
import {
  ajax
} from 'application/src/js/functions.js';
import {
  Mediator
} from 'application/src/js/util';

/**
 * @description modal for sending offer requests or plain text messages to the offer owner
 * @param {ModalWindow} modal
 * @param {SpinnerOverlay} loader
 */
export default class SendOfferModal extends Mediator {
  constructor(args) {
    super(args);
    this.modal = args.modal;
    this.loader = args.loader;

    this.form = this.modal.element.querySelector('form');
    this.formContent = this.modal.element.querySelector('.form-content');
    this.successMessage = this.modal.element.querySelector('.send-success-message');
    this.submitButton = this.modal.element.querySelector('button[type="submit"]');

    this.datepickerOptions = {
      allowInput: true,
      altInput: true,
      altFormat: dateFormats[selectedLanguage],
      dateFormat: 'Y-m-d',
      minDate: 'today',
      static: true
    }

    this.hideClass = 'hide';

    this.deliveryStartDateField = document.querySelector('input[name="delivery_start_date"]');
    if (this.deliveryStartDateField) this.deliveryStartDatepicker = flatpickr(this.deliveryStartDateField, this.datepickerOptions);

    this.deliveryStopDateField = document.querySelector('input[name="delivery_stop_date"]');
    if (this.deliveryStopDateField) this.deliveryStopDatepicker = flatpickr(this.deliveryStopDateField, this.datepickerOptions);

    this.submitURL = this.form.getAttribute('action');

    this.addEvents();
  }

  addEvents() {
    this.form.addEventListener('submit', e => {
      e.preventDefault();

      if (!this.form.checkValidity()) return;

      this.loader.show();

      this.sendMessage()
        .then(_ => {
          this.publish('sent', this);
          this.formContent.classList.add(this.hideClass);
          this.successMessage.classList.remove(this.hideClass);
          this.submitButton.classList.add(this.hideClass);
          this.loader.hide();
        })
        .catch(e => {
          if (this.debugMode) console.log(e);
          this.loader.hide();
        });
    });

    this.modal.subscribe('close', _ => {
      this.successMessage.classList.add(this.hideClass);
      this.formContent.classList.remove(this.hideClass);
      this.submitButton.classList.remove(this.hideClass);
    });
  }

  sendMessage() {
    return ajax(this.submitURL, {
      price: this.form.querySelector('input[name="price"]').value,
      inco_type: this.form.querySelector('select[name="inco_type"]').value,
      requested_volume: this.form.querySelector('input[name="requested_volume"]').value,
      currency_code: this.form.querySelector('select[name="currency_code"]').value,
      global_country_id: this.form.querySelector('select[name="global_country_id"]').value,
      delivery_location: this.form.querySelector('input[name="delivery_location"]').value,
      delivery_start_date: this.form.querySelector('input[name="delivery_start_date"]').value,
      delivery_stop_date: this.form.querySelector('input[name="delivery_stop_date"]').value,
      message: this.form.querySelector('textarea[name="message"]').value,
    });
  }
}